import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/api/football',
  withCredentials: true,   
});


const resyncData = async () => {
    const response = await apiClient.post('/resync/football');
    return response.data;
};

const getTournaments = async (params) => {
    const response = await apiClient.get('/tournaments', { params });
    return response.data;
};

const getCompetitions = async () => {
    const response = await apiClient.get('/competitions');
    return response.data;
};

const getMatches = async (params) => {
    const response = await apiClient.get('/matches', { params });
    return response.data;
};

const getLiveMatches = async () => {
    const response = await apiClient.get('/live-matches');
    return response.data;
};

const getAllRounds = async () => {
    const response = await apiClient.get('/rounds');
    return response.data;
};

const getMatchStatuses = async () => {
    const response = await apiClient.get('/match-statuses');
    return response.data;
};

const getTournamentDetails = async (tslug) => {
    const response = await apiClient.get(`/tournament/${tslug}`);
    return response.data;
};

const getMatchDetails = async (mslug) => {
    const response = await apiClient.get(`/match/${mslug}`);
    return response.data;
};
const toggleLiveBlog = async (data) => {
    const response = await apiClient.post('/config/toggle-live-blog', data);
    return response.data;
};

const getMatchConfigs = async (slugs) => {
    const response = await apiClient.post('/config/match-configs', { params: { slugs } });
    return response.data;
};
const getMatchesForCalendar = async (params) => {
    const response = await apiClient.get('/calendar-matches', { params });
    return response.data;
};
const toggleLiveBlogBatch = async (data) => {
    // data structure: { matches: [{slug, key}], status: true/false }
    const response = await apiClient.post('/config/toggle-batch', data);
    return response.data;
};
export default {
    resyncData,
    getTournaments,
    getCompetitions,
    getMatches,
    getLiveMatches,
    getAllRounds,
    getMatchStatuses,
    getTournamentDetails,
    getMatchDetails,
    toggleLiveBlog,
    getMatchConfigs,
    getMatchesForCalendar,
    toggleLiveBlogBatch
};